import * as contactHelpers from 'bundles/backoffice/contacts/helpers';

const primaryRolesByDealType = {
  buyer_rep: ['buyer', 'buyer_contact', 'client'],
  tenant_rep: ['tenant', 'tenant_contact', 'client'],
};

export function getPrimaryContact(deal) {
  const roles = primaryRolesByDealType[deal.dealType] || [];
  const primaryRole = deal.contactRoles.find(contactRole => roles.includes(contactRole.role));
  return primaryRole?.contact;
}

export function replaceContact(contact, deal) {
  return contactHelpers.replaceContact(contact, getContactParentsByType(deal));
}

function getContactParentsByType(deal) {
  return {
    commissions: deal.commissions,
    contactRoles: deal.contactRoles,
  };
}
